import { render } from "./CurrencySwitch.vue?vue&type=template&id=c2d3dafc&scoped=true&bindings={\"showSwitch\":\"options\",\"switchLabel\":\"options\",\"hasCurrencyChoices\":\"options\",\"switchCurrency\":\"options\",\"applySwitch\":\"options\"}"
import script from "./CurrencySwitch.vue?vue&type=script&lang=js"
export * from "./CurrencySwitch.vue?vue&type=script&lang=js"

import "./CurrencySwitch.vue?vue&type=style&index=0&id=c2d3dafc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2d3dafc"

export default script